module.exports = __webpack_public_path__ + "img/naomi-yourcarsold-car-buyers-dealers-rivervale-perth-wa.1842307d.jpg";